// extracted by mini-css-extract-plugin
module.exports = {"jurisdiction":"JurisdictionModal_jurisdiction__1AD9c","hidden":"JurisdictionModal_hidden__12Viw"};